/* eslint-disable */
import Comprehensive from '@/pages/adminCenter/page/comprehensive/index';
const ComprehensiveRouter = [{
  path: 'comprehensive',
  component: Comprehensive,
}]
export default [...ComprehensiveRouter]



// WEBPACK FOOTER //
// ./src/router/admin/en/comprehensive.js